var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "firstDeleteBulkModal",
        "aria-hidden": "true",
        "aria-labelledby": "exampleModalLabel",
        "data-backdrop": "static",
        role: "dialog",
        tabindex: "-1",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          attrs: {
            role: "document",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-content",
            },
            [
              _vm._m(0),
              _vm._m(1),
              _c(
                "div",
                {
                  staticClass: "modal-footer",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary",
                      attrs: {
                        "data-dismiss": "modal",
                        type: "button",
                      },
                    },
                    [_vm._v(" NO ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.emitSecondModal()
                        },
                      },
                    },
                    [_vm._v(" YES ")]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "modal-header",
      },
      [
        _c(
          "div",
          {
            staticClass: "container",
          },
          [
            _c(
              "div",
              {
                staticClass: "row",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "col-12",
                  },
                  [
                    _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: {
                          id: "exampleModalLabel",
                        },
                      },
                      [_vm._v(" Bulk delete inactive budget requests ")]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              "aria-label": "Close",
              "data-dismiss": "modal",
              type: "button",
            },
          },
          [
            _c(
              "span",
              {
                attrs: {
                  "aria-hidden": "true",
                },
              },
              [_vm._v("×")]
            ),
          ]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "modal-body",
      },
      [
        _c(
          "div",
          {
            staticClass: "container",
          },
          [
            _c(
              "div",
              {
                staticClass: "row",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "col-12",
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "This functionality will delete all inactive budget requests from PML."
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        "This action cannot be reverted. Are you sure you want to continue?"
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }